import { useDispatch, useSelector } from 'react-redux'
import {
  selectActiveAddress,
  selectPdlSearchData,
} from '@/containers/SubscriptionFormPageNew/SubscriptionForm/SubscriptionFormSelectors'
import {
  updateElectricityMeterAddressData,
  updatePdlSearchData,
} from '@/containers/SubscriptionFormPageNew/SubscriptionForm/SubscriptionFormSlice'

const usePdlSearchV2 = () => {
  const dispatch = useDispatch()
  const activeAddress = useSelector(selectActiveAddress)
  const {
    address,
    viewPage,
    contractType,
    occupant,
    matricule,
    pdlSelected,
    locality,
    building,
    serialNumber,
    complement,
    searchPodResponses,
    searchPodResponsesOriginal,
    isOpen,
    isLoading,
    page,
  } = useSelector(selectPdlSearchData)

  const resetPdlSearchData = () => {
    dispatch(
      updatePdlSearchData({
        searchPodResponses: [],
        searchPodResponsesOriginal: [],
        viewPage: 'search',
        address: {},
        occupant: '',
        serialNumber: '',
        complement: '',
        building: '',
        locality: '',
        contractType: 'part',
        matricule: '',
        page: 1,
        errorMessage: null,
        podSearchDataId: null,
      }),
    )
  }

  const handlePageChange = nextPage => {
    if (nextPage < 1) {
      return
    }
    if (nextPage > Math.ceil(searchPodResponses.length / 8)) {
      return
    }
    dispatch(updatePdlSearchData({ page: nextPage }))
  }

  const updateList = results => {
    dispatch(
      updatePdlSearchData({
        searchPodResponses: results,
        searchPodResponsesOriginal: results,
        triggerSearchPod: false,
        page: 1,
      }),
    )
  }

  const updatePdlConfigData = payload => {
    dispatch(updatePdlSearchData(payload))
  }

  const updateAddressHandler = address => {
    if (!address) {
      dispatch(updatePdlSearchData({ address: {} }))
      return
    }
    dispatch(
      updatePdlSearchData({
        address: address[0] ?? {
          address: '',
          label: '',
          city: '',
          inseeCode: '',
          zipcode: '',
          streetNumber: '',
          type: '',
        },
      }),
    )
  }

  const handleSelectPdl = pdlData => {
    dispatch(
      updateElectricityMeterAddressData({
        data: {
          pdlNo: pdlData.pdl || pdlData.pod_id,
          isValidPdl: true,
          oldOccupant: pdlData.finalClient,
          enedisAuth: false,
          consentDate: null,
          meterPower: null,
          meterOption: null,
        },
        id: activeAddress,
      }),
    )

    updatePdlConfigData({ isOpen: false })
    resetPdlSearchData()
  }

  const handleBackToSearch = () => {
    updatePdlConfigData({ viewPage: 'search' })
  }

  const isAddressFilled = Object.keys(address).length > 0

  return {
    isAddressFilled,
    currentViewPage: viewPage,
    getAddress: address,
    getZipCode: address.zipcode ?? '',
    getInseeCode: address.inseeCode ?? '',
    getContractType: contractType,
    getOccupant: occupant,
    getMatricule: matricule,
    getSerialNumber: serialNumber,
    getComplement: complement,
    getBuilding: building,
    getLocality: locality,
    currentSelectedOption: pdlSelected,
    searchPodResponses,
    searchPodResponsesOriginal,
    getStreetNumberName: `${address.streetNumber} ${address.address}`.trim(),
    getStreetNumber: address.streetNumber ?? '',
    getStreetName: address.address ?? '',
    resetPdlSearchData,
    isOpen,
    isLoading,
    updateList,
    updatePdlConfigData,
    updateAddressHandler,
    handlePageChange,
    page,
    handleSelectPdl,
    handleBackToSearch,
  }
}

export default usePdlSearchV2
